import React from "react";
import { useTranslation } from "react-i18next";

function JournalInfo({ doc }) {
  const { t } = useTranslation();
  return (
    <>
      <div>{t("requests.overview.preview.journal.info.email")}: rjesavatelj1@grad.hr</div>
      <div>{t("requests.overview.preview.journal.info.mobile")}: +385918741985</div>
    </>
  );
}

export default JournalInfo;
